import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
export function FloatingMobileCTA() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling down 500px
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <AnimatePresence data-id="element-96">
      {isVisible && <motion.div initial={{
      y: 100
    }} animate={{
      y: 0
    }} exit={{
      y: 100
    }} className="fixed bottom-0 left-0 w-full bg-white border-t border-gray-200 p-4 z-40 md:hidden shadow-[0_-10px_20px_rgba(0,0,0,0.1)]" data-id="element-97">
          <a href="https://comerfacil.shop/cart/44790229336179:1" className="block w-full bg-brand-orange text-white text-center font-bold py-3 rounded-full shadow-lg active:scale-95 transition-transform" data-id="element-98">
            QUIERO EL EBOOK AHORA
          </a>
        </motion.div>}
    </AnimatePresence>;
}